export default __webpack_public_path__ + "static/media/bg.7a5a6241.jpg";